<script lang="ts">
  import type { Snippet } from 'svelte';
  import PixelIcon, { type PixelIconName } from './PixelIcon.svelte';

  interface Props {
    /** Colour role. Never a raw colour — see styles/tokens.css. */
    variant?: 'accent' | 'p1' | 'p2' | 'positive' | 'danger' | 'ghost';
    disabled?: boolean;
    /** `submit` so a form's primary action also fires on Enter in a field. */
    type?: 'button' | 'submit';
    onclick?: () => void;
    icon?: PixelIconName;
    children: Snippet;
  }

  let {
    variant = 'accent',
    disabled = false,
    type = 'button',
    onclick,
    icon,
    children,
  }: Props = $props();
</script>

<!--
  Disabled changes colour and border style only. The box, the padding and the
  min-height are identical, so toggling it can never reflow the screen around it.
-->
<button
  {type}
  class="btn btn--{variant}"
  {disabled}
  aria-disabled={disabled}
  onclick={() => !disabled && onclick?.()}
>
  {#if icon}<PixelIcon name={icon} size={56} />{/if}
  <span class="btn__label">
    {@render children()}
  </span>
</button>
